(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relax-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__relaxFooterInit) return;
    window.__relaxFooterInit = true;

    // WhatsApp CTA -> Meta Pixel "Contact" + GA4 event, when those tags exist.
    // Delegated on document so it survives theme-editor section reloads.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.rf [data-rf-event]');
      if (!a) return;
      if (window.fbq) window.fbq('track', 'Contact', { content_name: 'footer_whatsapp' });
      if (window.gtag) window.gtag('event', a.getAttribute('data-rf-event'));
    });

    // One accordion open at a time, for browsers without exclusive <details name>.
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.classList || !d.classList.contains('rf-acc') || !d.open) return;
      var root = d.closest('.rf');
      if (!root) return;
      root.querySelectorAll('.rf-acc[open]').forEach(function (o) {
        if (o !== d) o.open = false;
      });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
